import React from 'react';
import api from '../../services/api.js';
import { toast } from 'react-toastify';
import UserPermission from '../../components/UserPermission';
import { TileLayer, Marker, MapContainer, useMapEvents } from 'react-leaflet';
import {
  TextField,
  Button,
  Typography,
  Grid
} from '@mui/material';

import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import BorderColorIcon from '@mui/icons-material/BorderColor';

const userPermission = UserPermission();

const classes = {
  textField: {
    width: '100%',
    backgroundColor: '#fff',
  },
  buttonSubmit: {
    marginTop: 20,
  },
  formControl: {
    marginLeft: 5,
    marginTop: 16,
    width: '50%'
  },
  textTitle: {
    margin: 8,
    color: '#103168',
    fontWeight: 600,
  },
  message: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%'
  },
  cardRoot: {
    borderRadius: '17px',
    backgroundColor: '#F5F5F5',
  },
  labelInput: {
    fontFamily: 'Rawline',
    color: '#333333',
    fontWeight: 'bold',
    paddingLeft: 2,
    fontSize: 14
  },
  buttonClear: {
    backgroundColor: '#F5F5F5',
    color: '#174FB3',
    borderRadius: 20,
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },
  buttonConfirm: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: 20,
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },
};

export default function SelectLocOnMap({ occurrence, setOpen }) {
  const [positionOccurrence, setPositionOccurrence] = React.useState([]);
  const [placeOccurrence, setPlaceOccurrence] = React.useState([]);

  function updateOccurrence() {
    if (userPermission === 'admin') {
      toast.error('O administrador não pode atualizar a localização, utilize uma conta de Controlador ou Executor');
      // let newOccurrence = occurrence;
      // let idComplaint = occurrence.id;

      // newOccurrence.latitude = positionOccurrence[0];
      // newOccurrence.longitute = positionOccurrence[1];
      // try {
      //   for (let i = 0; i < newOccurrence.statusList.length; i++)
      //     delete newOccurrence.statusList[i].id;
      // } catch (err) {
      //   console.log("Esta ocorrencia nao possui o statusList");
      // }

      // api.put(`${userPermission}/complaints/${idComplaint}`, newOccurrence);
    } else {
      let newOccurrence = {};
      let idComplaint = occurrence.id;

      newOccurrence.latitude = positionOccurrence[0];
      newOccurrence.longitute = positionOccurrence[1];

      try {
        api.put(`${userPermission}/complaints/${idComplaint}/geo`, newOccurrence);
        occurrence.latitude = newOccurrence.latitude;
        occurrence.longitute = newOccurrence.longitute;
      } catch (error) {
        console.log("Erro ao atualizar as informações de localização\n" + error);
      }

    }
    setOpen(false);
  }

  React.useEffect(() => {
    setPlaceOccurrence([occurrence.address, occurrence.neighborhood, occurrence.referencePoint]);
  }, [occurrence]);

  function UpdatePosition() {
    useMapEvents({
      click(e) {
        setPositionOccurrence([e.latlng.lat, e.latlng.lng]);
      },
    })
    return null
  }

  return (
    <>
      {placeOccurrence.length > 0 ?
        <>
          <Typography variant="h5" align="center" style={classes.textTitle}>
            Selecionar Localização
          </Typography>

          <div style={classes.message}>
            Clique no  local desejado para marcar a localização.
          </div>

          <Grid container justifyContent='space-between' spacing={2} style={{ marginBottom: 5 }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Typography style={classes.labelInput}>
                Rua:
              </Typography>

              <TextField
                fullWidth
                defaultValue={placeOccurrence[0] || 'Não informado'}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Typography style={classes.labelInput}>
                Bairro:
              </Typography>

              <TextField
                fullWidth
                defaultValue={placeOccurrence[1] || 'Não informado'}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Typography style={classes.labelInput}>
                Ponto de referência:
              </Typography>

              <TextField
                fullWidth
                defaultValue={placeOccurrence[2] || 'Não informado'}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
        </> : false
      }

      <Grid container>

        <Grid item xs={12} md={12}>
          <MapContainer center={[-6.5319859, -49.8526823]} zoom={14} scrollWheelZoom={false} style={{ width: "100%", height: '47vh' }}>
            <UpdatePosition />

            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {
              positionOccurrence.length !== 0 ?
                <Marker position={positionOccurrence}> </Marker> :
                false

            }
          </MapContainer>
        </Grid>

        {/* <hr></hr> */}


        <Grid container item spacing={2} justifyContent='center' >
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<AutoFixNormalIcon style={{ 'color': '#174FB3' }} />}
              type='button'
              onClick={e => setOpen(false)}
              style={classes.buttonClear}
            >
              Cancelar
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              startIcon={<BorderColorIcon style={{ 'color': '#fff' }} />}
              onClick={e => { updateOccurrence() }}
              style={classes.buttonConfirm}
            >
              Salvar Localização
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}